import { CreateRooms_Input } from 'generated/graphql';
import { StyledTextField } from 'modules/components/layer01';
import { SelectInstallationAreaField } from 'modules/components/layer04';
import { FormBaseLayout } from 'modules/components/layer10';
import * as ds from './dataService';

export type CreateRoomsFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: CreateRoomsFormProps) => {
  const [
    fnCreateRoomsForm,
    { loading }
  ] = ds.useCreateRooms();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (formState: ds.IFormState) => {
    const input: CreateRooms_Input = {
      projectId: formState.projectId,
      areasToCreate: [
        {
          areaId: formState.areaId,
          areaName: formState.displayName
        }
      ]
    };
    await fnCreateRoomsForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <SelectInstallationAreaField.FC
        form={form}
        fieldName='areaId'
      />
      <StyledTextField.FC
        {...form.genFieldProps('displayName')}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
